module.exports = __webpack_public_path__ + "static/media/Baslik.11575335.png";